module.exports = __webpack_public_path__ + "img/vatican.9d9bdac.webp";